module.exports = __webpack_public_path__ + "static/service-1-a5fc662bef607b6c85f133d20242b27f.jpg";